export * from './translations';
export * from './translate.pipe';
export * from './translate.service';



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/i18n/index.ts